import { rpxToPx } from '../../../utils/h5-rpx.js'
import { LINK_CHECKIN_ZONE_SIZE_RPX } from '../../../utils/act004-link-checkin-zone.js'

export function parseAct004HotspotNumber(value, fallback) {
	const raw = String(value == null ? '' : value)
		.replace(/%/g, '')
		.replace(/,/g, '')
		.trim()
	const num = parseFloat(raw)
	return Number.isFinite(num) ? num : fallback
}

/**
 * 与 activity-multi.getAct004CenterHotspotBoxStyle 一致：
 * left/top 为 750×1334 设计稿百分比中心点 + translate(-50%,-50%)
 */
export function getAct004CenterHotspotBoxStyle(hotspot, widthRpx, heightRpx, extraStyle, containerHeightPx) {
	const ww = typeof window !== 'undefined' ? window.innerWidth || 375 : 375
	const leftPct = parseAct004HotspotNumber(hotspot && hotspot.left, 50)
	const topPct = parseAct004HotspotNumber(hotspot && hotspot.top, 50)
	const w = (() => {
		const n = parseInt(widthRpx, 10)
		return Number.isFinite(n) && n > 0 ? n : LINK_CHECKIN_ZONE_SIZE_RPX
	})()
	const h = (() => {
		const n = parseInt(heightRpx, 10)
		return Number.isFinite(n) && n > 0 ? n : w
	})()
	const ch = parseFloat(containerHeightPx)
	const topValue =
		Number.isFinite(ch) && ch > 0
			? (topPct / 100) * ch + 'px'
			: rpxToPx((topPct / 100) * 1334, ww)
	return Object.assign(
		{
			position: 'absolute',
			left: rpxToPx((leftPct / 100) * 750, ww),
			top: topValue,
			width: rpxToPx(w, ww),
			height: rpxToPx(h, ww),
			transform: 'translate(-50%, -50%)',
			boxSizing: 'border-box'
		},
		extraStyle || {}
	)
}

/** 在活动锚点 top% 上叠加车展页面上移量（仅改位置） */
export function getCarvueAdjustedZoneAnchor(anchor, defaultTopPct, topOffsetPct) {
	const baseTop = parseAct004HotspotNumber(anchor && anchor.top, defaultTopPct != null ? defaultTopPct : 50)
	const off = parseAct004HotspotNumber(topOffsetPct, 0)
	return Object.assign({}, anchor || {}, {
		top: Math.max(32, baseTop + off)
	})
}

/**
 * 车展 H5 盖章热区：宽度铺满当前页，高度=宽度（正方形 aspect-ratio）
 * 触点仍按热区 rect 映射到 800×600，等比例放大不改变区内相对坐标，不影响印章比对
 */
export function getCarvueFullWidthSquareZoneStyle(hotspot, slideHeightPx, extraStyle) {
	const topPct = parseAct004HotspotNumber(hotspot && hotspot.top, 50)
	const ch = parseFloat(slideHeightPx)
	const topValue =
		Number.isFinite(ch) && ch > 0
			? (topPct / 100) * ch + 'px'
			: topPct + '%'
	return Object.assign(
		{
			position: 'absolute',
			left: '50%',
			top: topValue,
			width: '100%',
			maxWidth: '100%',
			height: 'auto',
			aspectRatio: '1 / 1',
			transform: 'translate(-50%, -50%)',
			boxSizing: 'border-box'
		},
		extraStyle || {}
	)
}

export function getCarvueSlideHeight(selector) {
	if (typeof document === 'undefined') return 0
	const slide = document.querySelector(selector)
	if (!slide) return 0
	return slide.getBoundingClientRect().height
}

export function applyStyleToElement(el, styleObj) {
	if (!el || !styleObj) return
	Object.keys(styleObj).forEach(function (key) {
		el.style[key] = styleObj[key]
	})
}
